import { Publish } from '@mui/icons-material';
import { green, grey, orange, red, yellow } from '@mui/material/colors';

import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de publicação de pauta.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_IMTIMACAO = {
    NAO_INTIMADO      : { id: 'NAO_INTIMADO', descricao: 'Não intimado',     cor: red[700] },
    INTIMADO          : { id: 'INTIMADO', descricao: 'Intimado', cor: green[300]   },
    INTIMADO_E_CIENTE : { id: 'INTIMADO_E_CIENTE', descricao: 'Intimado e ciente', cor: green[700]  }
}
